export default __webpack_public_path__ + "static/3.1-382a6e29b08b9ef991f06977a6e5a5ff.webp";